import { Observable } from 'rxjs';
import { Map } from 'immutable';

import {
  DonationScheduleWhereInput,
  DonationSchedulesQuery,
  DonationSchedulesQueryVariables,
  DonationSchedulesDocument,
  DonationScheduleFullQuery,
  DonationScheduleFullQueryVariables,
  DonationScheduleFullDocument,
  CancelDonationScheduleMutation,
  CancelDonationScheduleMutationVariables,
  CancelDonationScheduleDocument,
} from 'generated/graphql';

import { query, mutate } from '../graphql';

import { addMultipleAction, addAction } from './actions';
import DonationSchedule from './model';

export default class DonationScheduleApi {
  public static getByFilter(
    where: DonationScheduleWhereInput,
    forceRefetch = false
  ): Observable<{
    type: string;
    donationSchedules: Map<string, DonationSchedule>;
  }> {
    return Observable.from(
      query<DonationSchedulesQuery, DonationSchedulesQueryVariables>(
        DonationSchedulesDocument,
        { where },
        forceRefetch ? 'network-only' : 'cache-first'
      )
    ).map(({ errors, data }) => {
      if (errors) {
        throw new Error(JSON.stringify(errors));
      }

      return addMultipleAction(
        Map(
          data.donationSchedules.map((donationSchedule) => [
            new DonationSchedule(donationSchedule).id,
            new DonationSchedule(donationSchedule),
          ])
        )
      );
    });
  }

  public static fetchById(id: string): Observable<{
    type: string;
    donationSchedule: DonationSchedule;
  }> {
    return Observable.from(
      query<DonationScheduleFullQuery, DonationScheduleFullQueryVariables>(
        DonationScheduleFullDocument,
        { where: { id: { equals: id } } },
        'network-only'
      )
    ).map(({ errors, data }) => {
      if (errors) {
        throw new Error(JSON.stringify(errors));
      }

      if (!data.donationSchedules?.[0]) {
        throw new Error('No donation schedule found');
      }

      return addAction(new DonationSchedule(data.donationSchedules[0]));
    });
  }

  public static cancelDonationSchedule = (
    id: string
  ): Observable<{
    type: string;
    donationSchedule: DonationSchedule;
  }> =>
    Observable.from(
      mutate<CancelDonationScheduleMutation, CancelDonationScheduleMutationVariables>(
        CancelDonationScheduleDocument,
        { id }
      )
    ).map(({ errors, data }) => {
      if (errors) {
        throw new Error(JSON.stringify(errors));
      }

      if (!data?.cancelDonationSchedule) {
        throw new Error('No donation schedule found');
      }

      return addAction(new DonationSchedule(data.cancelDonationSchedule));
    });
}
